import { SxProps, Box } from "@mui/material";

export const RadioCircle = ({
  sx,
  checked,
  color = "green",
  size = 50,
}: {
  sx?: SxProps;
  checked?: boolean;
  color?: string;
  size?: number;
}) => {
  const innerSize = parseInt((size * 0.6).toFixed(0));
  const innerScale = checked ? 1 : 0;

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: "1px solid #a8a8a8",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center",
        borderColor: checked ? color : "#a8a8a8",
        ...sx,
      }}
    >
      <Box
        sx={{
          width: innerSize,
          height: innerSize,
          borderRadius: "50%",
          transform: `scale(${innerScale})`,
          backgroundColor: checked ? color : "transparent",
        }}
      />
    </Box>
  );
};
